<template>
  <div class="uploader box">
    <div class="field">
      <div class="control">
        <div class="file has-name is-fullwidth">
          <label class="file-label">
            <input
              class="file-input"
              type="file"
              id="file"
              ref="file"
              @change="handleFileUpload">

            <span class="file-cta">
              <span class="file-icon">
                <i class="fas fa-folder-open"></i>
              </span>
              <span class="file-label">{{ (uploading) ? 'Verzenden...' : label }}</span>
            </span>

            <span class="file-name">{{ (file) ? file.name : '' }}</span>
          </label>
        </div>
      </div>
    </div>

    <div class="field">
      <progress
        v-if="progress !== null"
        class="progress"
        max="100"
        :class="color"
        :value="progress"
      ></progress>
    </div>

    <save-buttons
      v-show="!auto"
      saveCaption="Uploaden"
      @save="submit"
      @close="clear"
      @cancel="$emit('cancel')"
      :disabled="!file"
    ></save-buttons>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SaveButtons from './SaveButtons'

export default {
  name: 'Uploader',

  props: {
    auto: {
      type: Boolean,
      default: false
    },

    label: {
      type: String,
      required: true
    },

    action: {
      type: String,
      required: true
    },

    formFields: {
      type: Object,
      default: () => null
    },

    uri: {
      type: String,
      default: 'files/upload'
    }
  },

  components: {
    SaveButtons
  },

  data () {
    return {
      file: null,
      formData: null
    }
  },

  computed: {
    ...mapGetters({
      progress: 'files/progress'
    }),

    color () {
      if (this.progress === null) return 'is-danger'
      if (this.progress === 100) return 'is-success'

      return 'is-info'
    },

    uploading () {
      return this.progress !== null && this.progress < 100
    }
  },

  methods: {
    handleFileUpload () {
      this.file = this.$refs.file.files[0]

      this.formData = new FormData()
      this.formData.append('file', this.file)

      if (this.formFields) {
        Object.keys(this.formFields).forEach(key => this.formData.append(key, this.formFields[key]))
      }

      if (this.auto) {
        this.submit()
      }
    },

    submit () {
      this.$store.dispatch(this.action, { uri: this.uri, payload: this.formData })
    },

    clear () {
      this.file = this.formData = null
    }
  }
}
</script>

<style scoped>
  .uploader {
    padding: 3.5rem;
  }
</style>
